<template>
  <div>
    <DsfrPagination
      class="mb-6"
      v-model="page"
      :length="Math.ceil(eatingExperienceCount / limit)"
      v-if="showPagination"
    />
    <v-sheet fluid height="200" v-if="inProgress">
      <v-progress-circular indeterminate style="left: 50%; top: 50%"></v-progress-circular>
    </v-sheet>
    <v-row v-else>
      <v-col
        cols="12"
        sm="6"
        md="4"
        height="100%"
        v-for="eatingExperience in eatingExperience_list"
        :key="`eatingExperience-${eatingExperience.id}`"
      >
        <EatingExperienceCard class="fill-height" :eatingExperience="eatingExperience" />
      </v-col>
      <v-col
        cols="12"
        sm="6"
        md="4"
        height="100%"
        class="d-flex flex-column"
        v-if="loggedUser.job == 'RESEARCHER' || loggedUser.job == 'NUTRITIONIST'"
      >
        <v-card
          class="d-flex flex-column align-center justify-center dsfr"
          outlined
          min-height="220"
          height="80%"
          :to="{ name: 'CreateEatingExperience' }"
        >
          <v-icon size="100" class="primary--text">mdi-plus</v-icon>
          <v-card-text class="font-weight-bold pt-0 text-center primary--text text-body-1">
            Créer une nouvelle recommandation
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <DsfrPagination
      class="my-6"
      v-model="page"
      :length="Math.ceil(eatingExperienceCount / limit)"
      v-if="showPagination"
    />
  </div>
</template>

<script>
import EatingExperienceCard from "./EatingExperienceCard"
import DsfrPagination from "@/components/DsfrPagination"

export default {
  name: "EatingExperiencePagination",
  components: { EatingExperienceCard, DsfrPagination },
  data() {
    return {
      limit: 6,
      page: null,
      // Liste complète renvoyée par l'API (l'endpoint n'est pas paginé côté serveur) : le
      // découpage par page se fait ici, sur `offset`/`limit`. Sans lui, toutes les cartes
      // s'affichaient et la pagination ne pilotait rien.
      allExperiences: [],
      canteenName: null,
      searchTerm: null,
      options: {
        sortBy: [],
        sortDesc: [],
        page: 1,
      },
      inProgress: null,
    }
  },
  computed: {
    loading() {
      return this.inProgress
    },
    eatingExperienceCount() {
      return this.allExperiences.length
    },
    eatingExperience_list() {
      return this.allExperiences.slice(this.offset, this.offset + this.limit)
    },
    showPagination() {
      return this.eatingExperienceCount > this.limit
    },
    offset() {
      return (this.page - 1) * this.limit
    },
    userPermissions() {
      return this.$store.state.userPermissions
    },
    loggedUser() {
      return this.$store.state.loggedUser
    },
  },
  methods: {
    search() {
      if (this.searchTerm && this.options.page !== 1) {
        this.options.page = 1
      } else {
        this.$router.push({ query: this.getUrlQueryParams() }).catch(() => {})
      }
    },
    getUrlQueryParams() {
      const urlQueryParams = { page: this.options.page }
      if (this.searchTerm) {
        urlQueryParams.recherche = this.searchTerm
      }
      return urlQueryParams
    },
    fetchCurrentPage() {
      this.inProgress = true
      this.$store
        .dispatch("fetchAllStudySurveys", { offset: this.offset, search: this.searchTerm })
        .then((response) => {
          this.allExperiences = response || []
        })
        .catch(() => {
          this.allExperiences = []
          this.$store.dispatch("notifyServerError")
        })
        .finally(() => {
          this.inProgress = false
        })
    },
    clearSearch() {
      this.searchTerm = ""
      this.search()
    },
    updateRoute() {
      const query = { page: this.page }
      if (this.$route.query.page) {
        this.$router.push({ query }).catch(() => {})
      } else {
        this.$router.replace({ query }).catch(() => {})
      }
    },
    populateParameters() {
      this.page = this.$route.query.page ? parseInt(this.$route.query.page, 10) : 1
    },
  },
  watch: {
    page() {
      this.updateRoute()
    },
    $route() {
      // Changer de page ne fait que redécouper la liste déjà chargée : inutile de tout
      // recharger. On ne remonte pas la page si seule la query `page` a bougé.
      this.populateParameters()
    },
  },
  mounted() {
    // Fetch inconditionnel : sans query d'URL, la liste restait vide et la pagination
    // n'apparaissait jamais (le fetch était conditionné à la présence d'une query).
    this.populateParameters()
    this.fetchCurrentPage()
  },
}
</script>
